import { atom } from "recoil";

export const printHousePreferencesState = atom({
  key: "printHousePreferencesState",
  default: [],
});
